import TextField from "@/components/form/textField/TextField"
import Icon from "@/components/icon/Icon"
import { SearchProps } from "@/types/components/search"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import "./search.scss"

export default function Search({ onChange, className, appendIcon = true, ...props }: SearchProps) {
  const { t } = useTranslation("")
  const [search, setSearch] = useState("")

  useEffect(() => {
    if (search.length > 0) {
      onChange?.(search)

      return
    }

    onChange?.("")
  }, [search])

  return (
    <TextField
      {...props}
      className={classNames("SearchCont", className)}
      placeholder={t("search")}
      prependIcon={!appendIcon && <Icon type="search" />}
      appendIcon={appendIcon && <Icon type="search" />}
      onChange={(e) => {
        setSearch((e.target as HTMLInputElement).value)
      }}
    />
  )
}
